export default {
	storeOidcUser: (state, user) => {
		state.oidc.user = user;
	},
	storeOidcInstance: (state, client) => {
		state.oidc.instance = client;
	},
	drawer: (state, payload) => {
		state.drawer = payload;
	},
	setFertigers: (state, payload) => {
		payload.forEach((p) => (p.isOpen = false));
		state.fertiger = payload;
	},
	setFertigerWorkplans: (state, payload) => {
		const fertiger = state.fertiger.find((f) => f.id == payload.fertigerId);
		if (fertiger != undefined) {
			const index = state.fertiger.indexOf(fertiger);
			if (index >= 0) {
				state.fertiger[index].workplanViewModels = payload.workplans;
			}
		}
	},
	setTransportProvider: (state, payload) => {
		state.transportProviders = payload;
	},
	beanstandungsCount: (state, payload) => {
		state.beanstandungsCount = payload;
	},
	beanstandungLoadedForFertigerId: (state, payload) => {
		state.beanstandungLoadedForFertigerId = payload;
	},
	setOrderCancellationRequests: (state, payload) => {
		state.orderCancellationRequests = payload;
	},
	setOrderCancellationRequest: (state, payload) => {
		let requestIndex = state.orderCancellationRequests.findIndex(
			(o) => o.blexonOrderId == payload.blexonOrderId
		);
		if (requestIndex >= 0) {
			state.orderCancellationRequests.splice(requestIndex, 1, payload);
		}
	},
	setProcessStep: (state, payload) => {
		let requestIndex = state.orderCancellationRequests.findIndex(
			(o) => o.blexonOrderId == payload.orderId
		);
		if (requestIndex >= 0) {
			let positionIndex = state.orderCancellationRequests[requestIndex].positions.findIndex(
				(p) => p.articleId == payload.articleId
			);
			if (positionIndex >= 0) {
				state.orderCancellationRequests[requestIndex].positions[
					positionIndex
				].currentProcessStep = payload.value;
			}
		}
	},
	setShowResolved: (state, payload) => {
		state.showResolved = payload;
	},
};
